import React from 'react';
import styled from "styled-components";
import { Utilities } from 's2s-app-service';
import ClipLoader from "react-spinners/ClipLoader";

const MainContainer = styled.div`
  width: 100%;
  height: ${props => props.hasHeader ? "calc(100vh - 220px)" : "100vh"};;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Text = styled.div`
    font-size: clamp(20px, 4vw, 34px);
    font-family: Open Sans;
    letter-spacing: 0.25px;
    margin-bottom: 32px;
`;

const Loading = ({hasHeader}) =>{
    // console.log('hasHeader', hasHeader)
    return (
        <MainContainer hasHeader={hasHeader}>
            <Text>{Utilities.getInstance().getIntlMessage("Loading", "Loading...")}</Text>
            <ClipLoader color={"#3555D9"} loading={true}  size={40} />
        </MainContainer>
    );
};

export default Loading;
